import organizersService from "../../../services/organizersService";
import rules from "../../../utils/utils";
export default {
  name: "manageorganizers",
  components: {},
  props: ["operation", "edititem"],
  data() {
    return {
      showDialog: true,
      isFormValid: false,
      rules: rules.getRules(),
      isSaving: false,
      addOrganizerPayLoad: {},
      firstName: "",
      lastName: "",
      phone: "",
      email: ""
    };
  },
  computed: {},
  mounted() {
    //populate the item details in edit mode
    if (this.edititem && this.operation == "update") {
      this.firstName = this.edititem.firstName;
      this.lastName = this.edititem.lastName;
      this.phone = this.edititem.phone;
      this.email = this.edititem.email;
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    addOrganizerClick() {
      if (this.$refs.organizerForm.validate()) {
        this.isSaving = true;
        this.addOrganizerPayLoad = {
          firstName: this.firstName,
          lastName: this.lastName,
          phone: this.phone,
          email: this.email,
          createdDate: this.parseDate(
            this.formatDate(new Date().toISOString().substr(0, 10))
          )
        };
        organizersService.createOrganizer(
          this,
          data => {
            if (data.isSuccess) {
              this.$toast.success(data.systemMessage);
              this.showDialog = false;
              //emit the event to refresh the organizers list
              this.$eventHub.$emit("organizerCreated");
              this.isSaving = false;
            } else {
              this.$toast.error(data.systemMessage);
            }
            this.isSaving = false;
          },
          error => {
            this.isSaving = false;
            console.log(error);
            this.$toast.error(
              "unable to add the organizer at this moment. Please try again later"
            );
          }
        );
      }
    },
    updateOrganizerClick() {
      if (this.$refs.organizerForm.validate()) {
        //logic to update

        this.showDialog = false;
        this.$eventHub.$emit("organizerCreated");
      }
    },
    clearClick() {
      this.$refs.organizerForm.reset();
    },
    cancelClick() {
      this.showDialog = false;
    }
  }
};
